import { WATERMARK } from "constants/chartCommons";
import { selectedLegendItems } from "../chart.functions";

export const getOptions = (series: Highcharts.SeriesOptionsType[], legendSelected: number[]): Highcharts.Options => {
    return {
        chart: {
            animation: false,
            className: "FunctionalChart",
            polar: true,
            type: "line",
            spacing: [0, 0, 0, 0],
            margin: [0, 0, 0, 0],
        },
        credits: {
            text: WATERMARK,
            href: "#",
            position: {
                align: "left",
            },
            style: {
                fontSize: "8px",
            },
        },
        title: {
            text: undefined,
        },
        xAxis: {
            gridLineWidth: 0,
            labels: {
                distance: 8,
                useHTML: true,
                style: {
                    fontSize: "10px",
                    color: "#84acbc",
                },
            },
            tickmarkPlacement: "on",
            lineWidth: 0,
        },
        yAxis: {
            gridLineInterpolation: "polygon",
            gridLineColor: "#84acbc",
            tickInterval: 10,
            labels: {
                useHTML: true,
                style: {
                    backgroundColor: "#fff",
                    color: "#84acbc",
                },
            },
        },
        tooltip: {
            pointFormat: "",
            padding: 0,
            backgroundColor: "#000000",
            borderWidth: 0,
            shared: false,
            useHTML: true,
            style: {
                color: "white",
                fontSize: "11px",
            },
        },
        legend: {
            verticalAlign: "bottom",
            itemWidth: 120,
            margin: 20,
        },
        plotOptions: {
            series: {
                marker: {
                    enabled: false,
                },
                enableMouseTracking: true,
                events: {
                    legendItemClick: function (this: Highcharts.Series) {
                        selectedLegendItems(this, legendSelected);
                    },
                },
            },
        },
        series,
        exporting: {
            menuItemDefinitions: {
                downloadPNG: { text: "Download PNG Image" },
                downloadSVG: { text: "Download SVG Image" },
            },
            buttons: {
                contextButton: {
                    menuItems: ["downloadPNG", "downloadSVG"],
                },
            },
            allowHTML: true,
            chartOptions: {
                pane: {
                    size: "80%",
                },
            },
        },
    };
};
